<template>
  <div id="addEvidence" class="modal fade" role="dialog">
    <div class="modal-dialog profile-confirm-poup">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header confirmpopup-bgcolor p-0">
          <div class="add-record-title">
            <div>{{ $t('addEvidence') }}</div>
            <div @click="closeModal()" class="close-icon cursor-pointer">
              <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
            </div>
          </div>
        </div>
        <div class="modal-body confirm-body evidences-table" >
          <div class="row m-0 " >
            <div class="col-md-12 add-evidence-header p-0">
                <span class="service-provider">{{$t('selectServiceProvider')}}</span>
            <div >
             <div class="col-md-6 p-0 service-dropdown ">
            <span class="service-provider-label">{{$t('selectServiceProviderLabel')}}</span>
              <multiselect
                class="service-provider-dropdown multiselect-single-dropdown mb-38"
                :placeholder="$t('select')"
                label="labName"
                :showLabels="false"
                openDirection="below"
                v-model="selectServiceProvider"
                :options="serviceProvidersList.map(provider => provider.labId)"
                :custom-label="(opt) => serviceProvidersList.find((x) => x.labId === opt).labName || ''"
                @select="getDetails"
              >
              <span slot="noResult">{{ $t('noElementsFound') }}</span>
              </multiselect>
            </div>
            <div class="col-md-12 p-0 evidence-type">
             <p class="service-provider">{{$t('selectEvidenceType')}}</p>
            </div>
            </div>
            </div>
            <div class="col-xs-12 pl-30 pr-0 ">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0 search-container-wraper search-outer">
                    <div class="search-container reg-search col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                    <div style="position:relative">
                        <search-box  v-model="searchValue" :searchCount="searchCount" @getList="filterContactsList" componentName="contactDetails"></search-box>
                    </div>
                    </div>
                </div>
            </div>
          <div class="col-xs-12 col-sm-12 col-md-12 pl-30 pr-0" >
              <div>
                <table class="table table-responsive evidencesDataList">

                    <tr style="background-color: #E6E6E6; !important;">
                    <th class="w-60" >  <div class="checkbox-wrapper cust_checkbox">
                      <label class="custom-checkbox">
                                  <input
                                    type="checkbox"
                                   v-model="isSelectAllEvidences"
                                   @change="setIsSelectEvidences"

                                  />
                           <span class="select-check"></span>
                          </label>
                        </div></th>
                      <th >
                        <div class="tableHeader cursor-pointer" @click="arrowDirection.evidence = -(arrowDirection.evidence), sortBy('requirement', arrowDirection.evidence)">
                          <div class="ellipsis header-title" :title="$t('evidenceRequired')">{{$t('evidenceRequired')}}</div>
                          <div class="arrow" :class="arrowDirection.evidence === 1 ? 'down-arrow' : 'up-arrow'"></div>
                        </div>
                      </th>

                    </tr>

                  <tbody ref="tbodyBox" v-if="renderFilterData && renderFilterData.length">
                    <tr
                    :class="selectedEvidences.includes(data.requirement_id)?'selected_row':index%2===0?'table_data_part1':'table_data_part2'"
                    v-for="(data, index) in renderFilterData" :key="index">
                      <td class="single-check-box w-60"> <div class="checkbox-wrapper">
                        <label class="custom-checkbox">
                                  <input
                                    type="checkbox"
                                    :value="data.requirement_id"
                                    v-model="selectedEvidences"
                                    @change="setIsSelectAllEvidences"

                                  />
                           <span class="select-check"></span>
                          </label>
                        </div></td>
                    <td  class="ellipsis regulation-data"><span :title="data.requirement">{{ data.requirement }}</span></td>

                    </tr>
                  </tbody>
                </table>
                <div v-if="renderFilterData.length === 0">
                      <p class="no-records-found">{{$t('noRecordsFound')}}</p>
                    </div>
              </div>
          </div>
            <loader :loadingStatus="loaderStatus"></loader>

          </div>
        </div>

        <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
          <div  class="">
            <button type="button" class="btn emergo-btn cancel-changes" @click="closeModal">{{ $t('cancel') }}</button>
          </div>

          <div  class="">
            <button type="button" class="btn emergo-btn emergo-primary-button submit-button" :disabled="!selectedEvidences.length" @click="submit()">{{ $t('submit') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import SearchBox from '../UIComponents/ULSearchBox.vue';
import {
  getLabsData,
} from '../../apis/representationResources';
import { getEvidenceType, RequestServiceProvider } from '../../apis/evidence';

export default {
  components: {
    SearchBox,
    Loader,
  },
  props: {
    ocpData: Array
  },
  data() {
    return {
      searchValue: '',
      renderFilterData: [],
      arrowDirection: {
        evidence: 1,
      },
      searchCount: 0,
      filterEvidenceData: [],
      loaderStatus: false,
      isPreviouslySearched: false,
      selectedEvidences: [],
      isSelectAllEvidences: false,
      selectServiceProvider: '',
      serviceProvidersList: []
    };
  },
  async created() {
    await this.getLabsInfo();
  },
  methods: {
    async submit() {
      this.loaderStatus = true;
      const payload = {
        evidenceType: 'EVD_OCP', serviceProviderId: this.selectServiceProvider, requirementId: this.selectedEvidences, registrationId: this.ocpData[0].productRegistrationId, regulationId: this.ocpData[0].regulationId
      };
      const response = await RequestServiceProvider(payload);
      if (response.status === 204) {
        this.loaderStatus = false;
        this.selectServiceProvider = '';
        this.renderFilterData = [];
        this.selectedEvidences = [];
        this.isSelectAllEvidences = false;
        this.$emit('loadData');
        this.closeModal();
      }
    },
    async getDetails() {
      this.searchCount = this.renderFilterData.length;
      this.loaderStatus = true;
      const response = await getEvidenceType(1);
      if (response) {
        this.renderFilterData = response;
        this.loaderStatus = false;
        if (this.renderFilterData) {
          this.filterEvidenceData = this.renderFilterData;
          this.searchCount = this.renderFilterData.length;
        }
      }
    },
    async getLabsInfo() {
      this.loaderStatus = true;
      this.serviceProvidersList = await getLabsData('');
      this.loaderStatus = false;
    },
    setIsSelectAllEvidences() {
      this.isSelectAllEvidences = this.selectedEvidences.length === this.renderFilterData.length;
    },
    setIsSelectEvidences(type) {
      if (type === 'deselect') { this.isSelectAllEvidences = false; }
      if (this.isSelectAllEvidences) this.selectedEvidences = this.renderFilterData.map((requirement) => requirement.requirement_id);
      else this.selectedEvidences = [];
    },
    closeModal() {
      this.isSelectAllEvidences = false;
      this.selectedEvidences = [];
      this.selectServiceProvider = '';
      this.renderFilterData = [];
      $('#addEvidence').modal('hide');
    },

    async getEvidencetDetails() {
      this.searchCount = this.renderFilterData.length;
      this.loaderStatus = true;
      const response = await getEvidenceType();
      if (response) {
        this.renderFilterData = response;
        this.loaderStatus = false;
        if (this.renderFilterData) {
          this.filterEvidenceData = this.renderFilterData;
          this.searchCount = this.renderFilterData.length;
        }
      }
    },
    sortBy(type, direction) {
      if (direction === 1) this.renderFilterData.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        this.renderFilterData.sort((a, b) => {
          if (a[type] === null) {
            a[type] = '';
          } else if (b[type] === null) {
            b[type] = '';
          }
          const firstElement = a[type].toUpperCase(); // ignore upper and lowercase
          const secondElement = b[type].toUpperCase(); // ignore upper and lowercase

          if (firstElement < secondElement) {
            return -1;
          }
          if (firstElement > secondElement) {
            return 1;
          }
          return 0;
        });
      }
    },
    filterContactsList() {
      if (this.searchValue) {
        this.filterEvidence();
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterEvidence();
        this.isPreviouslySearched = false;
      }
    },
    async filterEvidence() {
      const searchStr = this.searchValue.trim();
      this.renderFilterData = [];
      if (!searchStr.length) {
        this.renderFilterData = this.filterEvidenceData;
        this.searchCount = this.renderFilterData.length;
        return;
      }
      this.renderFilterData = this.filterEvidenceData.filter((evidence) => evidence.requirement.toLowerCase().includes(this.searchValue.toLowerCase()));
      this.searchCount = this.renderFilterData.length;
    },
  },
};
</script>

<style scoped>
.cancel-changes,
.cancel-changes:hover {
    background-color: #FFF;
    height: 44px;
    min-width: 90px;
    color: #000 !important;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 25px;
    float: right;
    cursor: pointer;
    padding: 9px 16px;
    border: 1px solid #000001;
}
.submit-button,
.submit-button:hover {
   height: 44px;
  min-width: 90px;
}
.selected_row {
  background: #ECF5FC;
}
.modal-header {
    background-color: #ffffff !important;
    border-bottom: 1px solid #d3d3d3 !important;
    border-top-right-radius: 6px!important;
    border-top-left-radius: 6px!important;
}
.modal-header .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    background-color: #ffffff !important;
}
.submit-button {
  font-size: 18px !important;
}

.add-record-title {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: #3E3E3E;
    padding: 17px 0px 16px 16px;
}
.close-icon {
    padding-right: 20px;
}

.modal-body {
    padding: 32px 70px 0px 40px;
}

.modal-footer {
    background-color: #fff !important;
    padding-right: 0px;
    border: none !important;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
}
.modal-content {
 border: none;
 border-top-right-radius: 6px!important;
 border-top-left-radius: 6px!important;
 border-bottom-right-radius: 0!important;
 border-bottom-left-radius: 0!important;
}

@media (min-width: 768px) {
.modal-dialog {
 width: 1147px;
 margin: 30px auto;
}
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: hidden;
}
.evidence-type {
  padding-top:40px;
  padding-left: 21px;
  margin-bottom: 14px;
}
.checkbox {
    position: relative;
}

input[type="checkbox"] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    width: 18px !important;
    height: 18px !important;
    left: 0;
    top: 0;
    margin: 0 !important;
}

.checkbox label:before {
    content: "";
    width: 18px !important;
    height: 18px !important;
    border: 2px solid #4D4D4D;;
    display: inline-block;
    position: absolute;
    left: 0;
    top: -2px;
    border-radius: 3px;
}

.checkbox input[type="checkbox"]:checked+label:before {
    background-color: #01518A;
    background-image: url(/static/images/icons/checkbox.svg);
    background-size: 12px 15px;
    background-repeat: no-repeat;
    background-position-x: center;
    border: none;

}
.checkbox label {
    cursor: auto;
    top: 5px;
    position: relative;
}
.checkbox-header {
  padding:  14px 14px 16px 12px !important;
}
.cust_checkbox {
    margin: 5px 13px 0px 12px;
    display: inline-block;
}
.checkbox-file {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 0px 0px !important;

}
.service-provider {
    color: #3E3E3E;
    font-size: 18px;
    font-weight: 600;
}
.single-check-box {
  padding: 15px 13px 0px 12px !important;
}
.service-dropdown {
  margin-top: 24px;
  padding-left:14px

}
.service-provider-label {
  color: #3E3E3E;
  font-size: 16px;
  font-weight: 400;
}
.ul-font-color {
  color:#00518A !important
}
.cancel-message {
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 0px !important;
    /* font-weight: 700; */
}

label>input[type="radio"] {
    display: none;
}

label>input[type="radio"]+*::before {
    content: "";
    display: inline-block;
    vertical-align: bottom;
    width: 18px;
    height: 18px;
    margin-right: 11px;
    margin-bottom: 4px;
    border-radius: 50%;
    border-style: solid;
    border-width: 1px;
    border-color: #00518a;
    border: 2px solid #4d4d4d;
}

label>input[type="radio"]:checked+*::before {
    background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
    border-color: #00518a;
    border: 2px solid #00518a;
}

.proceed-changes,
.proceed-changes:hover {
    background-color: #01518a;
    height: 44px;
    min-width: 127px;
    color: #ffffff !important;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 25px;
    float: right;
    cursor: pointer;
    padding: 10px 16px;
    /* text-transform: capitalize; */
}

/* .modal-dialog {
 min-width: 1034px  !important;
 margin: 30px auto;
} */

/* .add-evidence-header {
  padding:32px 8px 0px 40px
} */
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.pb-24 {
  padding-bottom: 24px;
}
.pb-14 {
  padding-bottom: 14px;
}
.pl-30 {
  padding-left: 30px;
}
.header-title{
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 0px !important;
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

.evidence-main{
    /* background-color: #E5E5E5 !important; */
    height: calc(88vh - 50px) !important;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 0px;
  column-gap: 7px
  /* justify-content: center; */
}
.evidencesDataList th .arrow {
  opacity: 1;
}
.evidencesDataList thead,

.evidencesDataList tbody,

.evidencesDataList tr:not(.evidencesDataList thead tr) {
 display: table;
 width: 100%;
table-layout: fixed;
}
.evidences-table::-webkit-scrollbar {
  width: 6px;
}
.evidences-table::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.evidences-table {
  max-height: calc(80vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
}
  .multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
  cursor: not-allowed;
}

.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
  margin-top: 8px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 44px;
    /* padding: 9px 40px 11px 11px; */
    padding: 11px 40px 11px 16px;
    border: 1px solid #4D4D4D !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 13px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top: 4px !important;
        cursor: not-allowed;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
        cursor: not-allowed;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;
  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999;
    overflow: visible;
    padding:0px
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important;
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
  .service-provider-dropdown.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select {
    padding-top: 0px !important;
  }
   .service-provider-dropdown.multiselect-single-dropdown
  {
    width: 100%;
  }
   .service-provider-dropdown.multiselect-single-dropdown >>> .multiselect__single
 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    margin-bottom: 0px;
  }
</style>
